import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { environment } from 'src/environments/environment';
import { ModalFeedbackReportComponent } from '../../modals/modal-feedback-report/modal-feedback-report.component';

@Component({
  selector: 'app-feedback-report-button',
  standalone: true,
  imports: [MatButtonModule, MatTooltipModule, TranslateModule],
  templateUrl: './feedback-report-button.component.html',
  styleUrls: ['./feedback-report-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackReportButtonComponent implements OnInit, OnDestroy {
  showButton = false;
  private subscription?: Subscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data)
      )
      .subscribe((data) => {
        this.showButton =
          !!environment.feedbackGloballyEnabled || !!data['feedbackEnabled'];
        this.cdr.markForCheck();
      });

    // Check initial route
    let route = this.activatedRoute;
    while (route.firstChild) route = route.firstChild;
    this.showButton =
      !!environment.feedbackGloballyEnabled ||
      !!route.snapshot.data['feedbackEnabled'];
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  openModal(): void {
    this.dialog.open(ModalFeedbackReportComponent, {
      panelClass: 'medium-dialog',
      width: '500px',
      data: {},
    });
  }
}
